import { ca } from '@cian/analytics';

export function trackShowMoreClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'more_jk',
    useLastProducts: true,
  });
}
